import type { HelpFile } from '../../types/help'
import { ExpressionEditorTestIds } from '../../../testids/ExpressionEditorTestIds'

export const expressionEditorHelp: HelpFile = {
  docPage: '/docs/reference/cel',
  texts: {
    [ExpressionEditorTestIds.expressionEditorTextarea]: 'Enter the CEL expression — use autocomplete to insert attribute references and operators.',
  },
}
